export class LeadArchivedOptionType {
    NOT_CONTACTED = 'not_contacted';
    NOT_INTERESTED = 'not_interested';
    OTHER = 'other';
    BY_PRICE = 'by_price';
    BY_FINANCING = 'by_financing';
    BY_APPRAISAL = 'by_appraisal';
    IMMATURE = 'immature';
    SAMEBRAND = 'samebrand';
    SAMEBRAND_DEALERSHIP = 'samebrand_dealership';
    ANOTHERBRAND = 'anotherbrand';
    ANOTHERBRAND_DEALERSHIP = 'anotherbrand_dealership';
}
